// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { IEnvironment } from './interfaces';

export const environment: IEnvironment = {
  apicEnabled: false,
  apiGateway: {
    postData: {
      grant_type: 'client_credentials',
      scope: 'APIC',
      x_ibm_client_id: 'cf3226d0bb2a8e697a65280397cf42b0',
    },
    url: 'https://apigateway-internal-sandbox.labcorp.com/lcd/playgroundint',
  },
  production: false,
  reduxDevToolsEnabled: true,
  restAPI: 'http://localhost:3000',
  okta: {
    clientId: '0oazkzmuqe188DZ920h7',
    issuer: 'https://labcorp-holdings-dev.oktapreview.com/oauth2/default',
    pkce: true,
    postLogoutRedirectUri: 'http://localhost:4200/logout',
    redirectUri: 'http://localhost:4200/login/callback',
    scopes: ['email', 'openid', 'profile', 'address', 'phone', 'offline_access', 'groups'],
  },
  useMockJenkinsEnvironmentFile: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
